<template>
  <div class="ucrs-tipsCard">
    <component
      :is="item.link.external ? 'a' : 'NuxtLink'"
      v-bind="item.link.external ? { href: item.link.href, target: '_blank', rel: 'noopener noreferrer' } : { to: item.link.href }"
      aria-hidden="true"
      tabindex="-1"
    >
      <div
        class="relative bg-cover bg-no-repeat bg-center rounded"
        :class="`ucrs-tipsCard__img--${size}`"
        :style="style"
      >
        <div class="absolute bottom-5 p-5">
          <p class="text-3xl font-bold text-white">
            {{ item.name }}
          </p>
          <p
            v-if="variant === 'textInside'"
            class="text-base text-white leading-tight"
          >
            <br />{{ item.title }}
          </p>
        </div>
      </div>
    </component>
    <div
      v-if="variant === 'textOutside'"
      class="flex flex-col flex-1 pt-10 px-5"
    >
      <p class="text-base font-bold mb-4">
        <component
          :is="item.link.external ? 'a' : 'NuxtLink'"
          v-bind="item.link.external ? { href: item.link.href, target: '_blank', rel: 'noopener noreferrer' } : { to: item.link.href }"
          aria-hidden="true"
          tabindex="-1"
        >
          {{ item.title }}
        </component>
      </p>
      <p v-if="item.subtitle" v-dompurify-html="item.subtitle"></p>

      <div class="flex items-center mt-12 mb-2">
        <component
          :is="item.link.external ? 'a' : 'NuxtLink'"
          class="text-sm text-blue font-bold uppercase focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue"
          v-bind="item.link.external ? { href: item.link.href, target: '_blank', rel: 'noopener noreferrer' } : { to: item.link.href }"
          :name="`&lid=${item.name}|homepage`"
          :aria-label="computedAriaLabel"
        >
          {{ item.link.text }}
        </component>
        <SvgIcon name="angle-right-blue" class="max-h-5 max-w-5 ml-6" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      },
    },
    img: {
      type: String,
      default: '',
    },
    gradient: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
    },
    variant: {
      type: String,
      default: 'textOutside',
    },
  },
  computed: {
    computedAriaLabel() {
      const { name, title, link } = this.item ?? {}
      return `${name}. ${title}. ${link?.text}`
    },
    style() {
      if (!this.img) return ''

      const image = this.$img(this.img)

      return this.gradient
        ? `background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 1%, rgba(0, 0, 0, 0.75)), url(${image})`
        : `background-image: url(${image})`
    },
  },
}
</script>

<style lang="postcss" scoped>
.ucrs-tipsCard {
  @apply flex flex-col h-full;

  &__img {
    &--medium {
      @apply h-100;
    }
  }
}
</style>
